import React from "react";

export default function CloverfieldLogo({
  width = 32,
  height = 32,
  color = "#AEE3FA",
  ...rest
}: {
  width?: number;
  height?: number;
  color?: string;
  [x: string]: any;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.1993 15.7343L15.7343 14.1992C15.8811 14.0525 16.1189 14.0525 16.2657 14.1992L17.8008 15.7343C17.9475 15.881 17.9475 16.1189 17.8008 16.2657L16.2657 17.8007C16.1189 17.9475 15.8811 17.9475 15.7343 17.8007L14.1993 16.2657C14.0525 16.1189 14.0525 15.881 14.1993 15.7343Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7343 0.110043L0.110044 15.7343C-0.0366811 15.8811 -0.0366813 16.1189 0.110043 16.2657L15.7343 31.89C15.8811 32.0367 16.1189 32.0367 16.2657 31.89L31.89 16.2657C32.0367 16.1189 32.0367 15.8811 31.89 15.7343L16.2657 0.110043C16.1189 -0.0366812 15.8811 -0.0366811 15.7343 0.110043ZM13.6638 5.59664L16.0718 8.00461L18.4797 5.59666C20.3641 6.03094 22.1535 6.98217 23.6217 8.45037C25.09 9.91862 26.0412 11.7081 26.4755 13.5926L24.0675 16.0006L26.4754 18.4085C26.0411 20.2928 25.0899 22.0822 23.6217 23.5504C22.1534 25.0187 20.3639 25.9699 18.4793 26.4042L16.0716 23.9965L13.6639 26.4041C11.7794 25.9699 9.98997 25.0186 8.52171 23.5504C7.0535 22.0822 6.10226 20.2927 5.66799 18.4083L8.07575 16.0006L5.66791 13.5927C6.10215 11.7082 7.05341 9.91866 8.52171 8.45037C9.98993 6.98214 11.7794 6.0309 13.6638 5.59664Z"
        fill={color}
      />
    </svg>
  );
}
